module.exports = function (fox) {
	'use strict';

	var FormElementValidator = require('../validator/elementValidator')(fox);

	var FormElementBase = fox.extend(function FormElementBase (params, form) {
		this.params = params || {};
		this.formLayer = form;
		
		this.key = this.params.name;
		this.valid = true;
		this.noValidate = this.params.noValidate;
		this.validateOnFly = this.params.validateOnFly;
		this.valuePostProcessing = (this.formLayer.getOption('valuePostProcessing') || []).concat(this.params.valuePostProcessing || []);
		
		if (fox.isArray(this.params.validators)) {
			var validator = this._createUserValidator();

			this.params.validators.forEach(validator.addChecker, validator);
		}

		this.__constructor();
	}, {
		__constructor: function () {
			var _this = this;
			var getter = null;

			if ('womContainer' in this.params) {
				if (fox.wom.isSelector(_this.params.womContainer)) {
					getter = function () {return _this.formLayer.rwom1(_this.params.womContainer);};
				} else if (fox.oop.instanceOf(_this.params.womContainer, 'Controller')) {
					getter = function () {return _this.params.womContainer;};
				} else if (fox.isFunction(_this.params.womContainer)) {
					getter = function () {return _this.params.womContainer();};
				}

				if (getter === null) {
					throw new Error('Wrong womContainer parameter. Accepts: womSelector like "#alias, .class, .etc", Function, Controller class instance.');
				}

				Object.defineProperty(this, 'womContainer', {
					enumerable: true,
					get: getter
				});
			}

			this.formLayer.handleEvent('@this', 'change_' + this.key, function (params) {
				if (this.skip) return false;

				this.formLayer.dispatchEvent('change', fox.merge({field: this.key}, params));

				if (this.validateOnFly && !this.noValidate) {
					this.validateWithBroadcast();
				}
			}.bind(this), {
				prefix: [this.key, 'element', 'on', 'change'].join('_'),
				sync: true
			});
		},
		/**
		 * 
		 * @return {any} [description]
		 */
		super: function () {
			var args = fox.clone(arguments);

			return fox.callSuperMethod.apply(this, args.concat('super'));
		},

		/**
		 * 
		 * @return {boolean} [description]
		 */
		inDom: function () {
			if (this.womContainer) {
				return this.womContainer.isEmbedded();
			}

			return this.formLayer.getFormContainer().isEmbedded();
		},

		init: function () {return this;},

		dispatchEvent: function (event, params) {
			this.formLayer.dispatchEvent([event, this.key].join('_'), fox.merge({}, params));
		},

		getValue: function () {
			if (this.valuePostProcessing.length) {
				this.value = this.valuePostProcessing.reduce(function (value, next) {
					return next(value, this.key);
				}.bind(this), this.value);
			}

			return this.value;
		},

		setValue: function (value, broadcast) {
			this.value = value;

			if (broadcast) this.dispatchEvent('change', {value: this.getValue()});

			return this;
		},
		reset: function () {
			this.value = '';

			return this;	
		},

		disable: function () {
			this.disabled = true;
			this.dispatchEvent('disabled', {disabled: this.disabled});

			return this;
		},
		enable: function () {
			this.disabled = false;
			this.dispatchEvent('enabled', {disabled: this.disabled});

			return this;
		},

		/**
		 *
		 * @return {Promise<object>|object} [description]
		 */
		validate: function () {
			if (this.noValidate)
				return this._returnValidateResult(true);

			if (!this.userValidator)
				return this._returnValidateResult(true);

			return this.userValidator.validate(this.getValue()).then(function (resp) {
				return fox.merge(resp, this._returnValidateResult(resp.result));
			}.bind(this));
		},
		
		/**
		 * 
		 * Validate with result broadcasting
		 * @return {Promise<object>|object} 
		 */
		validateWithBroadcast: function () {
			var validateResult = this.validate();
			var dispatch = function (data) {
				this.formLayer.dispatchEvent(!data.result ? 'form_not_valid' : 'form_valid', [data]);

				return data;
			}.bind(this);

			if (!fox.isPromise(validateResult)) {
				return dispatch(validateResult);
			}

			return validateResult.then(dispatch);
		},

		/**
		 * 
		 * @param  {boolean} result [description]
		 * @return {object}        [description]
		 */
		_returnValidateResult: function (result) {
			return { result: (this.valid = result), field: this.key };
		},

		/**
		 * 
		 * @return {FormElementValidator} [description]
		 */
		_createUserValidator: function () {
			return this.userValidator || (this.userValidator = new FormElementValidator(this));
		}
	}, null, 'FormElementBase');

	fox.FormElementBase = FormElementBase;

	return FormElementBase;
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/elements/base.js
// module id = 26
// module chunks = 0